export default __webpack_public_path__ + "static/media/black.d60ceec7.png";